<div class="wrapper">
  <img [src]="imageUris[size]" *ngIf="imageUris !== undefined" draggable="false">
</div>
